import { render, staticRenderFns } from "./channelorderreport.vue?vue&type=template&id=9a7bb7ec&"
import script from "./channelorderreport.vue?vue&type=script&lang=js&"
export * from "./channelorderreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports